<template>
  <div
    aria-modal="true"
    class="mdc-dialog"
    :class="classes"
    role="alertdialog"
    @MDCDialog:opening="onOpening"
    @MDCDialog:opened="onOpened"
    @MDCDialog:closing="onClosing"
    @MDCDialog:closed="onClosed"
  >
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface">
        <div tabindex="0" />
        <h2 v-if="$slots['header']" class="mdc-dialog__title" :key="opened">
          <slot name="header" />
        </h2>
        <div v-if="$slots['body']" class="mdc-dialog__content">
          <slot name="body" />
        </div>
        <slot />
        <footer v-if="$slots['actions']" class="mdc-dialog__actions">
          <slot name="actions" />
        </footer>
      </div>
    </div>
    <div class="mdc-dialog__scrim"></div>
  </div>
</template>

<script>
import { MDCDialog } from "@material/dialog";

export default {
  inheritAttrs: false,
  model: {
    prop: "open",
    event: "change"
  },
  props: {
    scrollable: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    stacked: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mdcDialog: undefined,
      slotObserver: undefined,
      opened: ""
    };
  },
  computed: {
    classes() {
      return {
        "mdc-dialog--scrollable": this.scrollable
      };
    },
    model: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    closeAction() {
      return this.closable ? "close" : "";
    }
  },
  watch: {
    open() {
      this.open ? this.mdcDialog.open() : this.mdcDialog.close();
    },
    stacked() {
      this.mdcDialog.autoStackButtons = this.stacked;
    },
    closable() {
      this.mdcDialog.escapeKeyAction = this.closeAction;
      this.mdcDialog.scrimClickAction = this.closeAction;
    }
  },
  mounted() {
    this.mdcDialog = MDCDialog.attachTo(this.$el);
    this.mdcDialog.autoStackButtons = this.stacked;
    this.mdcDialog.escapeKeyAction = this.closeAction;
    this.mdcDialog.scrimClickAction = this.closeAction;

    if (this.open) {
      this.mdcDialog.open();
    }

    this.slotObserver = new MutationObserver(() => this.updateSlots());
    this.slotObserver.observe(this.$el, {
      childList: true,
      subtree: true
    });
    this.updateSlots();
  },
  beforeDestroy() {
    if (this.slotObserver) {
      this.slotObserver.disconnect();
    }
    if (this.mdcDialog) {
      this.mdcDialog.destroy();
    }
  },
  methods: {
    onOpening() {
      this.$emit("opening");
    },
    onOpened() {
      this.$emit("opened");
      this.$el.setAttribute("aria-hidden", "true");
      this.opened = "true";
    },
    onClosing(event) {
      this.$emit("closing", event.detail);
      this.$el.removeAttribute("aria-hidden");
    },
    onClosed(event) {
      this.model = false;
      this.$emit("closed", event.detail);
    },
    updateSlots() {
      this.mdcDialog.layout();
    }
  }
};
</script>
